import React, { useState, useContext } from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import { Wrench, CirclePercent, Database, IterationCcw } from 'lucide-react';
import HouseCharacteristicsDataSection from './HouseCharacteristicsDataSection/HouseCharacteristicsDataSection';
import './style.css';
import { WindowSizeContext } from '/src/App';
const HouseCharacteristics = ({
    section_datapoints,
    all_datapoints,
    updatedDatapoints,
    handleDatapointChange,
    handleMarkProjectCompleted,
    handleClearAllChanges,
    handleUpdateAnalysis
}) => {
    const { deviceType } = useContext(WindowSizeContext);
    // Sort the section_datapoints alphabetically by associated_home_name (a --> z)
    section_datapoints.sort((a, b) => a.associated_home_name.localeCompare(b.associated_home_name));

    // Image variables
    const new_hub_house_image_filename = "house-lansdcape.webp";
    const new_hub_house_image_url = CreateCloudfrontUrl(new_hub_house_image_filename);

    const [selectedArea, setSelectedArea] = useState(null);

    // Handle click event, set area and clicking on same area sets to null
    const handleAreaClick = (id) => {
        if (selectedArea === id) {
            setSelectedArea(null);
        } else {
            setSelectedArea(id);
        }
    }

    // Map numeric IDs to house area classes based on the actual data
    const getAreaClass = (id, type) => {
        const areaMap = {
            '2': { id: 'roof', name: 'Roof' },           // First object in array has id '2'
            '1': { id: 'landscaping', name: 'Landscaping' },    // Second object has id '1'
            '6': { id: 'windows', name: 'Windows' },        // Third object has id '6'
            '10': { id: 'hvac', name: 'HVAC' },          // Fourth object has id '10'
            '7': { id: 'doors', name: 'Doors' },          // Fifth object has id '7'
            '14': { id: 'frame', name: 'Frame' },         // Sixth object has id '14'
            '4': { id: 'foundation', name: 'Foundation' },     // Seventh object has id '4'
            '9': { id: 'siding', name: 'Siding' },         // Eighth object has id '9'
            '5': { id: 'plumbing', name: 'Plumbing' },       // Ninth object has id '5'
            '13': { id: 'basement', name: 'Basement' },       // Tenth object has id '13'
            '99': { id: 'financials', name: 'Financials' },
            '11': { id: 'electrical', name: 'Electrical' },
            '8': { id: 'general-property', name: 'General Property' },
        };
        if (type === 'name') {
            return areaMap[id].name || 'unknown';
        } else {
            return areaMap[id].id || 'unknown';
        }
    };

    // Filter the datapoints to only include the selected area (using associated_house key), keep full list if no area is selected
    const filteredDatapointsArray = selectedArea ? section_datapoints.filter(datapoint => datapoint.associated_house === selectedArea) : null;
    const filteredDatapoints = (filteredDatapointsArray && filteredDatapointsArray.length > 0) ? filteredDatapointsArray[0].datapoints : [];
    console.log(filteredDatapoints);
    // Filter the filteredDatapoints to include only objects where user_form_data_category is 'project'
    const selectedAreaProjects = filteredDatapoints.filter(datapoint => datapoint.user_form_data_category === 'project');

    // Now filter it to where user_form_data_category is 'datapoint'
    const selectedAreaDatapoints = filteredDatapoints.filter(datapoint => datapoint.user_form_data_category === 'datapoint');


    // Filter the selectedAreaDatapoints to include only objects where portal_form_category has 'property_house' in it
    const selectedAreaPropertyHouseDatapoints = selectedAreaDatapoints.filter(datapoint => datapoint.portal_form_category.includes('property_house'));

    // Filter the selectedAreaDatapoints to include only objects where portal_form_category has 'property_experience' in it
    const selectedAreaPropertyExperienceDatapoints = selectedAreaDatapoints.filter(datapoint => datapoint.portal_form_category.includes('property_experience'));

    // Filter the selectedAreaDatapoints to include only objects where portal_form_category has 'financial' in it
    const selectedAreaFinancialDatapoints = selectedAreaDatapoints.filter(datapoint => datapoint.portal_form_category.includes('financial'));

    const datapointsToDisplay = []

    if (selectedAreaFinancialDatapoints.length > 0) {
        datapointsToDisplay.push({
            type: 'financial',
            title: 'Financial Details',
            datapoints: selectedAreaFinancialDatapoints,
        });
    }

    if (selectedAreaPropertyHouseDatapoints.length > 0) {
        datapointsToDisplay.push({
            type: 'house',
            title: `${getAreaClass(selectedArea, 'name')} Characteristics`,
            datapoints: selectedAreaPropertyHouseDatapoints,
        });
    }

    if (selectedAreaPropertyExperienceDatapoints.length > 0) {
        datapointsToDisplay.push({
            type: 'experience',
            title: `Past Events + Experiences`,
            // title: `${getAreaClass(selectedArea, 'name')} Experiences`,
            datapoints: selectedAreaPropertyExperienceDatapoints,
        });
    }

    if (selectedAreaProjects.length > 0) {
        datapointsToDisplay.push({
            type: 'projects',
            title: `Improvements Made`,
            // title: `${getAreaClass(selectedArea, 'name')} Experiences`,
            datapoints: selectedAreaProjects,
        });
    }

    // Create const called multipleCategories that is true if the length of the datapointsToDisplay array is greater than 1
    const multipleCategories = datapointsToDisplay.length > 1;

    const getUpdatedCount = (areaDatapoints, updatedDatapoints) => {
        return areaDatapoints.reduce((count, item) => {
            const isProject = item.user_form_data_category === 'project';

            // Check if this item exists in updatedDatapoints
            const exists = updatedDatapoints.some(updatedItem =>
                isProject
                    ? updatedItem.project_id === item.project_id // For projects
                    : updatedItem.id === item.id // For regular datapoints
            );

            return count + (exists ? 1 : 0);
        }, 0);
    };

    return (
        <div className={`personalize-analysis-home-hub-container ${datapointsToDisplay.length > 0 && 'area-has-been-selected'} ${deviceType}`}>
            <div className={`personalize-analysis-home-hub-container-home-section ${(updatedDatapoints.length !== 0 && datapointsToDisplay.length === 0) && 'no-datapoints-selected'} ${deviceType}`}>

                <div className={`view-projects__home-hub-container personalize-analysis-home-hub-container-${deviceType}`}>
                    {deviceType !== 'mobile' && (
                        <img
                            className="view-projects__home-hub-image"
                            src={new_hub_house_image_url}
                            alt="House diagram"
                        />
                    )}
                    <div className={` ${deviceType === 'mobile' ? 'personalize-analysis-house-areas-grid' : 'view-projects__house-area-markers'}`}>
                        {section_datapoints?.map((area) => {
                            const updatedCount = getUpdatedCount(area.datapoints, updatedDatapoints);

                            // See if any of the datapoints have been updated (reminder, project ids are project_id and datapoint ids are id)

                            return (
                                <div
                                    key={area.id}
                                    className={`
                            clickable house-project-marker-container
                            house-risk-marker-personalize-analysis
                            ${selectedArea === area.associated_house ? 'area-has-been-selected selected-area' : 'area-has-been-selected not-selected-area'} 
                            house-risk-marker-${getAreaClass(area.associated_house)} 
                            ${(datapointsToDisplay.length > 0 && selectedArea !== area.associated_house) && 'mini'}
                            ${deviceType}
                            `}
                                    onClick={() => handleAreaClick(area.associated_house)}
                                // style={{
                                //     border: `2px solid ${getRiskColor(area.risk_level)}`,
                                // }}
                                >
                                    <div
                                        className="house-risk-marker-header"
                                    // style={{
                                    //     backgroundColor: getRiskColor(area.risk_level),
                                    // }}
                                    >
                                        <span className="house-risk-marker-header-text">{area.associated_home_name}</span>
                                    </div>
                                    {
                                        area.form_count > 0 && (
                                            <div className="house-risk-marker-body">
                                                <Database size={16} />
                                                <span className="house-risk-marker-body-text"> {area.form_count}</span>
                                                {updatedCount > 0 && (
                                                    <>
                                                        <IterationCcw size={16} />
                                                        <span className="house-risk-marker-body-text">{updatedCount}</span>
                                                    </>
                                                )}
                                            </div>
                                        )
                                    }
                                </div>
                            )
                        })}
                    </div>
                </div>
                {updatedDatapoints.length > 0 &&
                    <div className="personalize-analysis-home-hub-buttons-container">
                        <button
                            className="personalize-analysis-home-hub-update-button box-shadow-standard"
                            onClick={handleUpdateAnalysis}
                        >
                            Update the Analysis With Your {updatedDatapoints.length === 1 ? `Change` : `${updatedDatapoints.length} Changes`}!
                        </button>
                        <button className="personalize-analysis-home-hub-clear-changes-button box-shadow-standard" onClick={handleClearAllChanges}>
                            Clear Changes
                        </button>
                    </div>
                }
                {(updatedDatapoints.length === 0 && datapointsToDisplay.length === 0) &&
                    <div className="personalize-analysis-home-hub-no-changes-container">
                        <p>Select a category to start playing with the data!</p>
                    </div>
                }
            </div>
            {datapointsToDisplay.length > 0 &&
                <div className="personalize-analysis-home-hub-selected-area-datapoints">
                    {datapointsToDisplay.map((section) => (
                        <HouseCharacteristicsDataSection
                            key={section.type}
                            datapoints={section}
                            multipleCategories={multipleCategories}
                            handleDatapointChange={handleDatapointChange}
                            handleMarkProjectCompleted={handleMarkProjectCompleted}
                            updatedDatapoints={updatedDatapoints}
                            selectedArea={selectedArea}
                        />
                    ))}
                </div>
            }
        </div>
    );
};

export default HouseCharacteristics;